import React, { memo } from 'react';
import { Card } from '@highereducation/hen-ui';
import StatisticHighlight from './StatisticHighlight';
import TextBox from './TextBox';
import GraphicCard from './GraphicCard';
import { getSideRailConfigsForStep } from './getSideRailConfigsForStep';
import { useDynamicExperienceContext } from '@de/providers/DynamicExperienceProvider';
import type {
  StatisticHighlightConfig,
  TextBoxConfig,
  GraphicCardConfig,
  SideRailConfigItem,
} from '@de/types/types';

const SideRail: React.FC = () => {
  const { currentStep } = useDynamicExperienceContext();

  const sideRailConfigs = getSideRailConfigsForStep(currentStep);

  const renderConfigItem = (configItem: SideRailConfigItem) => {
    switch (configItem.type) {
      case 'statisticHighlight':
        return (
          <StatisticHighlight
            key={configItem.id}
            {...(configItem.config as StatisticHighlightConfig)}
          />
        );
      case 'textBox':
        return (
          <TextBox
            key={configItem.id}
            {...(configItem.config as TextBoxConfig)}
          />
        );
      case 'graphicCard':
        return (
          <GraphicCard
            key={configItem.id}
            {...(configItem.config as GraphicCardConfig)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Card
      variant='background-gray'
      data-test='side-rail'
      className='w-full md:self-start md:max-w-96 md:min-w-80 rounded-[32px] gap-8 px-8 py-7'
    >
      {sideRailConfigs.map(renderConfigItem)}
    </Card>
  );
};

export default memo(SideRail);
